import React from "react";
import NavBar from "../widgets/NavBar2";
import Footer from "../widgets/Footer";
import LearnMore from "../widgets/Idea";

import TeamWork from "../../assets/undraw_teamwork_hpdk.png";
import Wallet from "../../assets/undraw_wallet_aym5.png";
import BusinessDeal from "../../assets/undraw_Business_deal_re_up4u.png";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
  Box,
  Text,
  Button,
  UnorderedList,
  ListItem,
  Image,
  Icon
} from "@chakra-ui/react";

import { InfoOutlineIcon } from "@chakra-ui/icons";

export default function Home() {
  return (
    <Flex flexDirection="column">
      <NavBar />
      <Flex
        marginTop="10"
        flexDirection="column"
        justifyContent="center"
        alignItems="center">
        <Flex flexDirection="column" marginTop="10">
          <Text
            marginTop={4}
            fontWeight="bold"
            fontSize={{ base: 28, md: 32 }}
            ml={{ base: 4, md: 0 }}>
            Small Bids, Amazing Results!
          </Text>
          <Text fontSize={{ base: 15, md: 18 }} ml={{ base: 4, md: 0 }}>
            Astroworkers empowers students, house wifes or anyone who want to
            earn money online.{" "}
          </Text>
        </Flex>
        <Flex mb={{ base: 0, sm: 7 }}>
          <Image src={TeamWork} alt="Team Work" />
        </Flex>
      </Flex>
      <LearnMore />
      <Flex
        mt={{ base: 20, md: 0 }}
        flexDirection={{ base: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center">
        <Flex
          flexDirection="column"
          mt={{ base: 20, md: 0 }}
          paddingTop={{ base: 10, sm: 20, md: 0 }}>
          <Text
            mt={{ base: 0, sm: 20, md: 0 }}
            pt={{ base: 0, sm: 20, md: 0 }}
            fontWeight="bold"
            fontSize={{ base: "24", md: "28" }}
            marginLeft={{ base: "4", md: "120" }}
            marginBottom="4">
            As a Freelancer
          </Text>
          <Text
            fontSize={{ base: "14", md: "18" }}
            marginLeft={{ base: "4", md: "120" }}>
            you can earn money by simplying doing small tasks like sign up,
            joining groups, surveys, etc. it's fast and takes little time to
            complete and we send payments weekly.
          </Text>
        </Flex>

        <Flex>
          <Image src={Wallet} alt="Freelancers" />
        </Flex>
      </Flex>
      <Flex
        marginTop="30"
        flexDirection={{ base: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center">
        <Flex flexDirection="column">
          <Text
            fontWeight="bold"
            fontSize={{ base: "24", md: "28" }}
            marginLeft={{ base: "4", md: "120" }}
            marginBottom="4">
            As a Busines Owner
          </Text>
          <Text
            fontSize={{ base: "14", md: "18" }}
            marginLeft={{ base: "4", md: "120" }}>
            You can start jobs that help to promote your business (website,
            android or ios app, social media) or help you to do something that
            cannot do by yourselves.
          </Text>
        </Flex>
        <Flex>
          <Image src={BusinessDeal} alt="Business Owners" />
        </Flex>
      </Flex>
      <Flex
        mt={{ base: 0, md: 10 }}
        ml={{ base: 0, md: 10 }}
        flexDirection="row"
        justifyContent="center"
        alignItems="center">
        <Flex
          mb={10}
          pb={10}
          flexDirection="column"
          width="100%"
          ml={{ base: 0, md: 10 }}
          justifyContent="center">
          <Text
            color="yellow.500"
            fontWeight="bold"
            ml={{ base: 0, md: 10 }}
            textAlign={{ base: "center", md: "left" }}>
            ABOUT
          </Text>
          <Flex
            flexDirection="row"
            justifyContent={{ base: "center", md: "left" }}>
            <Text
              marginTop={3}
              marginBottom={7}
              ml={{ base: 0, md: 10 }}
              // width="50%"
              width={{
                base: "90%",
                md: "80%",
                "3md": "70%",
                "2md": "60%",
                "3lg": "630px"
              }}>
              Astroworkers is an online marketplace that connects Freelancers
              around the world with business owners. Businesses who need other
              people to help them to support their work come to Astroworkers.
              Here they can hire workers for easy and quick jobs.
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            justifyContent={{ base: "center", md: "left" }}>
            <Flex
              ml={{ base: 0, md: 10 }}
              flexDirection="row"
              alignItems="center"
              padding={5}
              borderRadius="4"
              bg="blue.400"
              width={{
                base: "90%",
                md: "80%",
                "3md": "70%",
                "2md": "60%",
                "3lg": "630px"
              }}>
              <Icon as={InfoOutlineIcon} marginRight="2" color="white" />

              <Text color="white">
                We also accept payments in cryptocurrency and payout in crypto!
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        margin={4}
        flexDirection="row"
        justifyContent="center"
        alignItems="center">
        <Flex flexDirection="column" w={{ base: "80vw", "3lg": "750px" }}>
          <Text marginStart={3} marginBottom={7} marginTop={21} fontSize={19}>
            Frequently asked questions
          </Text>
          <Accordion allowMultiple>
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    What is Success Rate?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                Workers must maintain a success rate of above 75% at all times
                (Satisfied tasks). Too many Not-Satisfied tasks will lower
                Worker's success rate. Low success rate prevents a Worker from
                performing jobs for the next 30 days.
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Do job creators get charged for every task?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                Businesses pay only for tasks they are satisfied with.
                Astroworkers does not charge a fees for tasks that do not meet
                requirements set in the job. All job owners will have a chance
                to rate every submitted task.
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Unacceptable jobs
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                We do not accept any job that attempts to harm a third party. No
                spam or scam jobs will be approved. It is not acceptable to ask
                freelancers to: Use a credit card or disclose their credit card
                information, Provide bank account details, Spam or harm a
                website, Use any form of payment to finish a task, Exchange
                money between payment systems, Create fake reviews, Give
                negative rating or negative feedback, Sign up to website
                requiring activation or membership fee, Sign up for a free trial
                or similar offers that might risk payment charges after free
                trial expires, Perform more than 3 connected tasks in a single
                Campaign, Asking for proofs to be emailed (all proofs must be
                submitted on site).
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Job fees
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                In order to maintain a world class 24/7 platform with a fully
                staffed administration team, we must charge fees. Please think
                of our administrators as your work team partners. We charge fees
                to approve every job, correct jobs, monitor the submmitted
                tasks, and provide support services. Job approval fee is $0.65.
                Fee for tasks rated Satisfied is 7% charged to both worker and
                employer.
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
}
